import { render, staticRenderFns } from "./Yjzx.vue?vue&type=template&id=79bc64ac&"
import script from "./Yjzx.vue?vue&type=script&lang=js&"
export * from "./Yjzx.vue?vue&type=script&lang=js&"
import style0 from "./Yjzx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports